<script setup lang="ts">
import CreateJobForm from './components/form/CreateJobForm.vue'

definePage({
  meta: {
    permissionLevel: 'Write',
    permissionResource: 'Job',
  },
})
</script>

<template>
  <CreateJobForm />
</template>
